import { Box } from "@chakra-ui/react";
import { useItineraries } from "~/api/resources/Itineraries";
import { listParams } from "~/api/listParams";
import { mediaUrl } from "~/lib/media";
import { useMemo } from "react";
import { Polaroid } from "~/components/Polaroid";
import { ShieldHeader } from "~/components/ShieldHeader";
import { Marquee } from "../Marquee";

type Props = {
  text?: string;
  buttonText?: string;
  filterByPage?: boolean;
  itinerary_id?: number;
};

export const RoadTripCardCarousel = ({ itinerary_id }: Props) => {
  const { records } = useItineraries(listParams);
  const itineraries = useMemo(
    () => records.filter((i) => i.id !== itinerary_id),
    [records, itinerary_id],
  );

  return (
    <Box my={24}>
      <ShieldHeader>Start packing for your next trip</ShieldHeader>
      <Marquee>
        {itineraries.map((itinerary, index) => {
          const odd = index % 2 === 1;
          return (
            <Polaroid
              mt={odd ? 10 : 0}
              mb={10}
              key={itinerary.id}
              image={mediaUrl(itinerary.lead_media)}
              rotate={odd ? "right" : "left"}
              title="Road Trip"
              name={itinerary.name}
              href={`/roadtrips/${itinerary.slug}`}
            />
          );
        })}
      </Marquee>
    </Box>
  );
};
